import { setClientFallbackRegion } from '@mentimeter/http-clients';
import { getRegionBySeriesId } from '@mentimeter/region';

export const setupRegion = (seriesId: string) => {
  const region = getRegionBySeriesId(seriesId);
  return setClientFallbackRegion('core', region);
};
